import { useEffect, useState } from "react";

import { useDebounce, useMerchantApiQuery } from ".";
import { IOnboardingStatus } from "../interfaces-and-types";

export const useShowHomepageOnboardingModal = (delayMs = 2500) => {
  const isDebounceElapsed = useDebounce(delayMs);

  const { isSuccess, data: onboardingStatus } =
    useMerchantApiQuery<IOnboardingStatus>("getOnboardingStatus", {
      enabled: isDebounceElapsed,
    });

  const [showHomepageOnboardingModal, setShowHomepageOnboardingModal] =
    useState(false);

  const closeHomepageOnboardingModal = () =>
    setShowHomepageOnboardingModal(false);

  let timeoutId: NodeJS.Timeout;
  useEffect(() => {
    if (
      (isDebounceElapsed &&
        isSuccess &&
        onboardingStatus &&
        !onboardingStatus.is_account_activation_requested) ||
      false
    ) {
      timeoutId = setTimeout(
        () => setShowHomepageOnboardingModal(true),
        delayMs
      );
    }

    return () => timeoutId && clearTimeout(timeoutId);
  }, [isSuccess, isDebounceElapsed]);

  return {
    showHomepageOnboardingModal,
    closeHomepageOnboardingModal,
  };
};
